import React from 'react';

import './AnalyticsPlatformUsetmxOverview.scss';

import Tooltips from '../../atoms/Tooltip/Tooltip';

// import * as moment from 'moment';

const AnalyticsPlatformUsetmxOverview = ({ loading, responseData, overallDataSetType }) => {
  return (
    <>
      <div className="tmx-analyticsPlatformUsetmxOverview__clearedGrid tmx-analyticsPlatformUsetmxOverview__clearedGrid--top">
        {loading ? (
          <div className="tmx-analyticsNetworkNewsroomOverview__clearedBubble tmx-analyticsNetworkNewsroomOverview__clearedBubble--basicInfoTop">
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--number"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--subTitle"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
          </div>
        ) : (
          <div className="tmx-analyticsNetworkNewsroomOverview__clearedBubble tmx-analyticsNetworkNewsroomOverview__clearedBubble--basicInfoTop">
            <Tooltips
              disableMouseHover
              content="New newsroom accounts created with TMX."
              direction="bottom">
              <h1 className="tmx-analyticsNetworkNewsroomOverview__basicInfoTopTitle">
                {responseData?.media?.video_downloads}
              </h1>
              <h1 className="tmx-analyticsNetworkNewsroomOverview__basicInfoTopSubTitle">
                {overallDataSetType === 'This Day'
                  ? 'Daily'
                  : overallDataSetType === 'This Week'
                  ? 'Weekly'
                  : 'Monthly'}{' '}
                Video downloads
              </h1>
            </Tooltips>
          </div>
        )}
        {loading ? (
          <div className="tmx-analyticsPlatformUsetmxOverview__clearedBubble tmx-analyticsPlatformUsetmxOverview__clearedBubble--basicInfoTop">
            <div className="tmx-analyticsPlatformUsetmxOverview__titleMock tmx-analyticsPlatformUsetmxOverview__titleMock--number"></div>
            <div className="tmx-analyticsPlatformUsetmxOverview__titleMock"></div>
            <div className="tmx-analyticsPlatformUsetmxOverview__titleMock tmx-analyticsPlatformUsetmxOverview__titleMock--subTitle"></div>
            <div className="tmx-analyticsPlatformUsetmxOverview__titleMock tmx-analyticsPlatformUsetmxOverview__titleMock--bar"></div>
            <div className="tmx-analyticsPlatformUsetmxOverview__titleMock tmx-analyticsPlatformUsetmxOverview__titleMock--bar"></div>
            <div className="tmx-analyticsPlatformUsetmxOverview__titleMock tmx-analyticsPlatformUsetmxOverview__titleMock--bar"></div>
            <div className="tmx-analyticsPlatformUsetmxOverview__titleMock tmx-analyticsPlatformUsetmxOverview__titleMock--bar"></div>
            <div className="tmx-analyticsPlatformUsetmxOverview__titleMock tmx-analyticsPlatformUsetmxOverview__titleMock--bar"></div>
          </div>
        ) : (
          <div className="tmx-analyticsPlatformUsetmxOverview__clearedBubble tmx-analyticsPlatformUsetmxOverview__clearedBubble--basicInfoTop">
            <Tooltips
              disableMouseHover
              content="Users engaging with TMX within a specific amount of time."
              direction="bottom">
              <h1 className="tmx-analyticsPlatformUsetmxOverview__basicInfoTopTitle">
                {responseData?.media?.video_uploads}
              </h1>
              <h1 className="tmx-analyticsPlatformUsetmxOverview__basicInfoTopSubTitle">
                {overallDataSetType === 'This Day'
                  ? 'Daily'
                  : overallDataSetType === 'This Week'
                  ? 'Weekly'
                  : 'Monthly'}{' '}
                Video uploads
              </h1>
            </Tooltips>
          </div>
        )}

        {loading ? (
          <div className="tmx-analyticsPlatformUsetmxOverview__clearedBubble tmx-analyticsPlatformUsetmxOverview__clearedBubble--basicInfoTop">
            <div className="tmx-analyticsPlatformUsetmxOverview__titleMock tmx-analyticsPlatformUsetmxOverview__titleMock--number"></div>
            <div className="tmx-analyticsPlatformUsetmxOverview__titleMock"></div>
            <div className="tmx-analyticsPlatformUsetmxOverview__titleMock tmx-analyticsPlatformUsetmxOverview__titleMock--subTitle"></div>
            <div className="tmx-analyticsPlatformUsetmxOverview__titleMock tmx-analyticsPlatformUsetmxOverview__titleMock--bar"></div>
            <div className="tmx-analyticsPlatformUsetmxOverview__titleMock tmx-analyticsPlatformUsetmxOverview__titleMock--bar"></div>
            <div className="tmx-analyticsPlatformUsetmxOverview__titleMock tmx-analyticsPlatformUsetmxOverview__titleMock--bar"></div>
            <div className="tmx-analyticsPlatformUsetmxOverview__titleMock tmx-analyticsPlatformUsetmxOverview__titleMock--bar"></div>
            <div className="tmx-analyticsPlatformUsetmxOverview__titleMock tmx-analyticsPlatformUsetmxOverview__titleMock--bar"></div>
          </div>
        ) : (
          <div className="tmx-analyticsPlatformUsetmxOverview__clearedBubble tmx-analyticsPlatformUsetmxOverview__clearedBubble--basicInfoTop">
            <Tooltips
              disableMouseHover
              content="Newsrooms engaging with TMX within a specific amount of time."
              direction="bottom">
              <h1 className="tmx-analyticsPlatformUsetmxOverview__basicInfoTopTitle">
                {responseData?.media?.article_downloads}
              </h1>
              <h1 className="tmx-analyticsPlatformUsetmxOverview__basicInfoTopSubTitle">
                {overallDataSetType === 'This Day'
                  ? 'Daily'
                  : overallDataSetType === 'This Week'
                  ? 'Weekly'
                  : 'Monthly'}{' '}
                Article downloads
              </h1>
            </Tooltips>
          </div>
        )}

        {loading ? (
          <div className="tmx-analyticsPlatformUsetmxOverview__clearedBubble tmx-analyticsPlatformUsetmxOverview__clearedBubble--basicInfoTop">
            <div className="tmx-analyticsPlatformUsetmxOverview__titleMock tmx-analyticsPlatformUsetmxOverview__titleMock--number"></div>
            <div className="tmx-analyticsPlatformUsetmxOverview__titleMock"></div>
            <div className="tmx-analyticsPlatformUsetmxOverview__titleMock tmx-analyticsPlatformUsetmxOverview__titleMock--subTitle"></div>
            <div className="tmx-analyticsPlatformUsetmxOverview__titleMock tmx-analyticsPlatformUsetmxOverview__titleMock--bar"></div>
            <div className="tmx-analyticsPlatformUsetmxOverview__titleMock tmx-analyticsPlatformUsetmxOverview__titleMock--bar"></div>
            <div className="tmx-analyticsPlatformUsetmxOverview__titleMock tmx-analyticsPlatformUsetmxOverview__titleMock--bar"></div>
            <div className="tmx-analyticsPlatformUsetmxOverview__titleMock tmx-analyticsPlatformUsetmxOverview__titleMock--bar"></div>
            <div className="tmx-analyticsPlatformUsetmxOverview__titleMock tmx-analyticsPlatformUsetmxOverview__titleMock--bar"></div>
          </div>
        ) : (
          <div className="tmx-analyticsPlatformUsetmxOverview__clearedBubble tmx-analyticsPlatformUsetmxOverview__clearedBubble--basicInfoTop">
            <Tooltips
              disableMouseHover
              content="New user accounts created with TMX."
              direction="bottom">
              <h1 className="tmx-analyticsPlatformUsetmxOverview__basicInfoTopTitle">
                {responseData?.media?.article_uploads}
              </h1>
              <h1 className="tmx-analyticsPlatformUsetmxOverview__basicInfoTopSubTitle">
                {overallDataSetType === 'This Day'
                  ? 'Daily'
                  : overallDataSetType === 'This Week'
                  ? 'Weekly'
                  : 'Monthly'}{' '}
                Article uploads
              </h1>
            </Tooltips>
          </div>
        )}
      </div>
    </>
  );
};

AnalyticsPlatformUsetmxOverview.propTypes = {};

export default AnalyticsPlatformUsetmxOverview;
